// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3FZxx","signatureBlock":"Footer_signatureBlock__1wYLY","signature":"Footer_signature__3D0H6"};